import { Typography } from '@material-ui/core';
import React from 'react';
import './UIFormTitle.css';

const UIFormTitle = ({ title, id, ...rest }) => (
  <Typography id={id} paragraph noWrap className="UIFormTitle">
    {title}
  </Typography>
);

export default UIFormTitle;
